<script lang="ts">
    import { onMount } from 'svelte';
    import Login from '../components/Login/Login.svelte';
    import { addClassName } from '../helpers';

  onMount(() => addClassName())
</script>

<Login />
